/**
 * template created by GreatJiang
 * 通用Vue模板
 */
class Activity {
  constructor() {
    this.refsrc = commonObj.utils.getQueryStrFn('refsrc') || 'none';
    this.siteId = '1277788313' //site id
    this.outCB = (commonObj.browser.ua.indexOf('changba') < 0) || commonObj.browser.isQQorWeChat || commonObj.browser.isWeibo || /cblive/.test(commonObj.browser.ua);
    this.userid = commonObj.data.userid;
    this.token = commonObj.data.token;
  }

  init() {
    const _czc = this._czc = window._czc || [];
    if (_czc) {
      _czc.push(["_setAccount", this.siteId]);
      _czc.push(["_trackEvent", `商城${this.refsrc}`, commonObj.data.outChangba ? 'outCB' : 'inCB', 'loaded', 0, 'body']);
    }
    this.vueAction()
  }

  vueAction() {
    const activityThis = this;
    const u = navigator.userAgent;
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    const vivo = u.toLowerCase().indexOf('vivo');
    const oppo = u.toLowerCase().indexOf('oppo');
    const wx = u.toLowerCase();

    return new Vue({
      el: '#app',
      data() {
        return {
          imgUrl: 'https://cbshowhot.cdn.changbaimg.com/!/yingjian/love-life',
          link: {
            g1: 'http://mall.changba.com/web/goods_detail.php?productid=216',
            c2: 'http://mall.changba.com/web/goods_detail.php?productid=305',
            c1: 'http://mall.changba.com/web/goods_detail.php?productid=2',
            aqua2: 'https://mall.changba.com/web/goods_detail.php?groupid=42&productid=336',
            xiaobang: 'http://mall.changba.com/web/goods_detail.php?productid=260',
            // button: 'http://mall.changba.com/web/goods_detail.php?productid=305',
            button: 'http://mall.changba.com/web/goods_detail.php?productid=216'
          },
          loadingFlag: false, //loading
          mesLayerFlag: false, //信息弹窗
          mesContent: ''  //信息弹窗内容
        }
      },
      mounted() {
        this.shareAll()
      },
      filters: {

      },
      methods: {
        goHref(goods) {
          if (_czc) {
            _czc.push(["_trackEvent", `商城-${goods}-点击量`, commonObj.data.outChangba ? 'outCB' : 'inCB', 'loaded', 0, 'body']);
          }
          setTimeout(() => {
            window.location.href = this.link[goods]
          }, 500)
        },
        mesLayerAction(content) {
          // 信息弹窗
          this.mesLayerFlag = true
          this.mesContent = content
          setTimeout(() => {
            this.mesLayerFlag = false
            this.mesContent = ''
          }, 2000)
        },
        // 添加一个站外打开的常用方法
        openApp() {
          if (activityThis.outCB) {
            if (wx.match(/micromessenger/i) == "micromessenger" && isiOS) {
              this.maskFlag = true
              const ele = document.getElementsByClassName('open-mask')[0]
              ele.style.display = "block"
              ele.onclick = function() {
                ele.style.display = "none"
              }
            } else {
              var c = confirm('前往唱吧进行参与~');
              if (c) {
                window.location.href = "changba://?ac=webview&customurl=" + commonObj.utils.base64encode('https://changba.com/njwap/yingjian/love-life/mall/main?wScratch=1')
              }
            }
            return false;
          }
        },
        shareAll() {
          const params = {
            title: '向往的生活明星同款',
            content: '彭昱畅也逃不过的明星麦克风，向往的生活同款喇叭麦，唱出向往的生活~',
            weibocontent: '彭昱畅也逃不过的明星麦克风，向往的生活同款喇叭麦，唱出向往的生活~',
            imageurl: 'http://cb.cdn.changbaimg.com/images/logo_300x300.jpg',
            thumburl: 'http://cb.cdn.changbaimg.com/images/logo_300x300.jpg',
            targeturl: location.protocol + '//changba.com/njwap/yingjian/love-life/mall/main?wScratch=1'
          };
          window.setShareUrlParams = function() {
            return JSON.stringify(params);
          };
          commonObj.data.setWXShare = function(wx) {
            const shareData = {
              title: '向往的生活明星同款',
              link: 'https://changba.com/njwap/yingjian/love-life/mall/main?wScratch=1',
              imgUrl: 'https://cb.cdn.changbaimg.com/images/logo_300x300.jpg',
              desc: '彭昱畅也逃不过的明星麦克风，向往的生活同款喇叭麦，唱出向往的生活~'
            };
            wx.onMenuShareTimeline(shareData);
            wx.onMenuShareAppMessage(shareData);
            wx.onMenuShareQQ(shareData);
            wx.onMenuShareWeibo(shareData);
            wx.onMenuShareQZone(shareData);
          };
        }
      }
    })
  }
}

new Activity().init();
